import m from 'mithril'
import { search_icon } from '../icons'

const Component = {
    oncreate: vnode => {
        vnode.state.focus = false

        if (vnode.attrs.focus != vnode.state.focus && vnode.attrs.id) {
            if (vnode.attrs.focus) {
                document.getElementById(vnode.attrs.id)?.focus()

            }

        }
        vnode.state.focus = vnode.attrs.focus
    },
    onupdate: vnode => {
        if (vnode.attrs.focus != vnode.state.focus && vnode.attrs.id) {
            if (vnode.attrs.focus) {
                document.getElementById(vnode.attrs.id)?.focus()

            }

        }
        vnode.state.focus = vnode.attrs.focus
    },

    view: function (vnode) {

        return [
            m('.input',
                { class: vnode.attrs.class + ' ' + (vnode.attrs.value ? 'has_input' : '') },
                m('input.general_input',
                    {
                        id: vnode.attrs.id,
                        value: vnode.attrs.value || '',
                        class: (vnode.attrs.search ? 'search_input' : ''),
                        placeholder: vnode.attrs.placeholder,
                        onfocus: () => { if (vnode.attrs.onfocus) vnode.attrs.onfocus() },
                        onfocusout: (e) => {
                            if (!(e.relatedTarget && e.relatedTarget.id == 'x_icon')) {
                                if (vnode.attrs.onfocusout) vnode.attrs.onfocusout()
                            }
                        },
                        oninput: e => {
                            vnode.attrs.onchange(e.target.value)
                        }
                    }
                ),

                //Show if text or focus

                vnode.attrs.search ? [
                    m(search_icon, {
                        class: 'search_glass ',
                        size: 44
                    }),

                    // vnode.attrs.value ?
                    m('button.x_icon',
                        {
                            id: 'x_icon',
                            onclick: () => {
                                vnode.attrs.onchange('')
                                if (vnode.attrs.onfocusout) vnode.attrs.onfocusout()
                                let this_x_icon = document.getElementById('x_icon')
                                if (this_x_icon) this_x_icon.blur()
                            }
                        }, m('.x_icon_line_1'), m('.x_icon_line_2'))
                    // : []
                ] : ''
            )
        ]
    }

}


export default Component



